export const COMMENT_HISTORY_HEADER = {
  SORT_BY: 'Sort by',
  CLEAR_FILTERS: 'Clear filters',
  CREATED_AT_LABEL: 'Date',
  SEVERITY_LABEL: 'Severity',
};

export const COMMENT_CATEGORY_FILTER = {
  PLACEHOLDER: 'Comment Category',
};

export const COMMENT_SEVERITY_FILTER = {
  SEVERITY_LOW_LABEL: 'Nice to have',
  SEVERITY_MEDIUM_LABEL: 'Important',
  SEVERITY_HIGH_LABEL: 'Critical issue',
  SEVERITY_NOT_APPLICABLE_LABEL: 'Not applicable',
  PLACEHOLDER: 'Comment Severity',
};

export const COMMENT_TYPE_FILTER = {
  INLINE_LABEL: 'Inline',
  SUMMARY_LABEL: 'Summary',
  REPLY_LABEL: 'Reply',
  SUMMARY_REPLY_LABEL: 'Summary Reply',
  PLACEHOLDER: 'Comment Type',
};

export const COMMENT_HISTORY = {
  COMMENT_CATEGORY_FILTER,
  COMMENT_SEVERITY_FILTER,
  COMMENT_TYPE_FILTER,
  PAGE_TITLE: 'PullRequest Comment History',
  PAGE_SUBTITLE:
    "All comments left by PullRequest reviewers on your organization's {PR_NAME} for the selected date range.",
  BREADCRUMB_TITLE: 'Comment History',
  EMERGENCY_BANNER_TITLE: 'Currently unavailable:',
  EMERGENCY_BANNER_DESCRIPTION:
    'Please return to this page when comments are available.',
  NO_DATA_BANNER_TITLE: 'No data',
  NO_DATA_BANNER_TEXT:
    "It looks like we don't have any PullRequest comments to display for the currently selected date range. Try selecting a different range, or come back once your organization has sent a {PR_NAME} to our network.",
  LOOSEN_FILTERS_TITLE: 'No data',
  LOOSEN_FILTERS_TEXT:
    "It looks like we don't have any comments to display for your currently selected filters. Try selecting different filters.",
};
